export default "__VITE_ASSET__BArioV2T__"